export default "__VITE_ASSET__DAqJdm$9__"